module.exports = __webpack_public_path__ + "static/media/Sector6.e4883c1d.jpg";